
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import headerImg from "../../Assets/images/why-kalemon1.png";
import greenBg from "../../Assets/images/bg-green.png"
import icon1 from "../../Assets/images/Group 1.png"
import icon2 from "../../Assets/images/Group 2.png"
import { Link } from 'react-router-dom';
import './howYouLearn.css'
import img1 from "../../Assets/images/Vector5.png"
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Modal } from 'antd';
import RegistrationPopup from '../registrationPopUp/RegistrationPopup';

const WhyKalemon = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);


    return (

        <div className="why-kalemon">
            <section className='first-section'>
                <h2 className='mb-3'>{t("why_choose_kalemon")}</h2>
                <p className='mb-4'>
                    {t("why_choose_kalemon_desc")}
                </p>
            </section>
            <Row className='justify-content-start flex-column '>
                <Col md={12} className='green-div'>
                    <div className='ap-second-section d-flex justify-content-start px-5 align-items-center '>
                        <button className='btn fw-bold' onClick={() => setIsModalOpen(true)}>{t("start_now")}</button>
                    </div>
                </Col>
            </Row>

            <section className='my-5 k12-grade'>
                <Container>
                    <h2 className='text-center '>{t("kalemon_difference_title")}</h2>
                    <p className='text-center'>{t("kalemon_difference_desc")}</p>
                </Container>
            </section>

            <section>
                <Container>
                    <div className='third-section my-5'>


                        <div id="carouselExampleIndicators1" className="carousel slide my-5" data-bs-ride="carousel" data-bs-interval="5000">
                            <div className="carousel-indicators">
                                <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                                <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                            </div>

                            <div className="carousel-inner">
                                {/* Slide 1 */}
                                <div className="carousel-item active">
                                    <div className="row my-3 pb-5 gx-5 mx-5">
                                        <div className="col-lg-6 cursol-item-container">
                                            <img src={greenBg} alt='' className='green-bg ' />
                                            <div className='card-content'>
                                                <h5 className='mt-3'>{t('digital_platform')}</h5>
                                                <h3>{t('digital_platform_desc')}</h3>
                                            </div>
                                            <img src={icon1} alt='' className='icon-img ' />
                                        </div>
                                        <div className="col-lg-6 cursol-item-container">
                                            <img src={greenBg} alt='' className='green-bg ' />
                                            <div className='card-content'>
                                                <h5 className='mt-3'>{t('expert_teachers')}</h5>
                                                <h3>{t('certified_instructors')}</h3>
                                            </div>
                                            <img src={icon2} alt='' className='icon-img ' />
                                        </div>
                                    </div>
                                </div>

                                {/* Slide 2 (duplicate or can be changed) */}
                                <div className="carousel-item ">
                                    <div className="row my-3 pb-5 gx-5 mx-5">
                                        <div className="col-lg-6 cursol-item-container">
                                            <img src={greenBg} alt='' className='green-bg ' />
                                            <div className='card-content'>
                                                <h5 className='mt-3'>{t('Proven_Methodology')}</h5>
                                                <h3>{t('structured_curriculum')}</h3>
                                            </div>
                                            <img src={icon1} alt='' className='icon-img ' />
                                        </div>
                                        <div className="col-lg-6 cursol-item-container">
                                            <img src={greenBg} alt='' className='green-bg ' />
                                            <div className='card-content'>
                                                <h5 className='mt-3'>{t('expert_teachers')}</h5>
                                                <h3>{t('certified_instructors')}</h3>
                                            </div>
                                            <img src={icon2} alt='' className='icon-img ' />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">{t('testimonials.prev')}</span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">{t('testimonials.next')}</span>
                            </button>
                        </div>
                    </div>
                    <div className="last-sec my-5 d-flex justify-content-center align-items-center w-100">
                        <Link
                            to="/how-we-learn"
                            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                        >
                            <button className="btn btn-primary" >
                                {t("how_you_learn")}
                            </button>
                        </Link>
                    </div>

                </Container>
            </section>

            <section className='impact-numbers py-5'>
                <h1 className='text-center'>{t("impact_numbers_title")}</h1>
                <Row>
                    <Col lg={3} className='text-center'>
                        <h2>50K+</h2>
                        <p>{t("students_worldwide")}</p>
                    </Col>
                    <Col lg={3} className='text-center'>
                        <h2>95%</h2>
                        <p>{t("success_rate")}</p>
                    </Col>
                    <Col lg={3} className='text-center'>
                        <h2>35</h2>
                        <p>{t("countries_served")}</p>
                    </Col>
                    <Col lg={3} className='text-center'>
                        <h2>10</h2>
                        <p>{t("years_of_excellence")}</p>
                    </Col>
                </Row>
            </section>

            <section className='fifth-section mt-5'>
                <Container>
                    <h4>{t('success_stories')}</h4>
                    <img src={img1} alt='' className='w-100' />
                    <Link to={""} className='join-community my-2 w-100'>{t("join_community")} </Link>
                    <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel" data-bs-interval="5000">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0"
                                className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"
                                aria-label="Slide 2"></button>
                        </div>

                        <div className="carousel-inner">

                            <div className="carousel-item active">
                                <div className="row my-3 pb-5 gx-5 mx-5">
                                    <div className="col-lg-6">
                                        <div className="card h-100">
                                            <p>{t("testimonial_1_text")}</p>
                                            <h5 className='mt-3'>{t("testimonial_1_author")}</h5>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="card h-100">
                                            <p>{t("testimonial_2_text")}</p>
                                            <h5 className='mt-3'>{t("testimonial_2_author")}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">{t('testimonials.prev')}</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">{t('testimonials.next')}</span>
                        </button>
                    </div>
                </Container>
                <div className='fifth-section-footer mt-5'>
                    <h3>{t('experience_kalemon_difference')}</h3>
                    <p>{t('experience_kalemon_difference_desc')}</p>
                    <div className='fifth-section-footer-btns '>
                        <button className='btn takeplacement' onClick={() => navigate("/all-programs")}>{t('explore_programs')}</button>
                        <button className='btn explore' onClick={() => navigate("/contact-us")}>{t('contact_us')}</button>
                    </div>
                </div>
            </section>
            <Modal
                open={isModalOpen}
                footer={null}
                destroyOnClose
                onCancel={() => setIsModalOpen(false)}
                width={"80vw"} // close handler
            >
                <RegistrationPopup setIsModalOpen={setIsModalOpen} />
            </Modal>
        </div>
    )
}

export default WhyKalemon
